import { Link } from 'react-router-dom';
import { USER_TYPE_CONFIG, REGISTERABLE_USER_TYPES } from '@/shared/types/users.types';

export function FooterSection() {
    return (
        <footer className="bg-teal-900 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-4 gap-10">

                    {/* Brand */}
                    <div className="md:col-span-1">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
                                <i className="ri-truck-line text-white" />
                            </div>
                            <span className="text-2xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                                ONAPILA
                            </span>
                        </div>
                        <p className="text-teal-300 text-sm leading-relaxed mb-4">
                            La plateforme de livraison intelligente pour l'Afrique.
                            Communautaire, adaptée, sécurisée.
                        </p>
                        <div className="flex gap-3">
                            {['ri-facebook-fill', 'ri-twitter-x-fill', 'ri-instagram-line', 'ri-whatsapp-line'].map(icon => (
                                <a key={icon} href="#"
                                    className="w-9 h-9 bg-teal-800 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors">
                                    <i className={`${icon} text-sm`} />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Inscriptions */}
                    <div>
                        <h4 className="font-semibold text-sm uppercase tracking-wider text-teal-300 mb-4">
                            S'inscrire
                        </h4>
                        <ul className="space-y-2">
                            {REGISTERABLE_USER_TYPES.map(type => {
                                const cfg = USER_TYPE_CONFIG[type];
                                return (
                                    <li key={type}>
                                        <Link to={`/register/${type}`}
                                            className="text-teal-200 hover:text-orange-400 text-sm transition-colors flex items-center gap-1.5">
                                            <i className={`${cfg.icon} text-xs text-teal-400`} />
                                            {cfg.label}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>

                    {/* Navigation */}
                    <div>
                        <h4 className="font-semibold text-sm uppercase tracking-wider text-teal-300 mb-4">
                            Navigation
                        </h4>
                        <ul className="space-y-2 text-sm text-teal-200">
                            {[
                                { to: '/login', label: 'Se connecter', icon: 'ri-login-circle-line' },
                                { to: '/tracking', label: 'Suivi de colis', icon: 'ri-map-pin-line' },
                                { to: '/mobile-money', label: 'Mobile Money', icon: 'ri-smartphone-line' },
                                { to: '/guest-checkout', label: 'Commande invité', icon: 'ri-user-2-line' },
                                { to: '/offline-features', label: 'Mode hors ligne', icon: 'ri-wifi-off-line' },
                            ].map(item => (
                                <li key={item.to}>
                                    <Link to={item.to}
                                        className="hover:text-orange-400 transition-colors flex items-center gap-1.5">
                                        <i className={`${item.icon} text-xs text-teal-400`} />
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-semibold text-sm uppercase tracking-wider text-teal-300 mb-4">
                            Contact & Support
                        </h4>
                        <div className="space-y-3 text-sm text-teal-200">
                            <div className="flex items-start gap-2">
                                <i className="ri-phone-line text-teal-400 mt-0.5" />
                                <div>
                                    <p>+224 620 00 00 00</p>
                                    <p className="text-xs text-teal-400">Lun–Sam 7h–21h</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-2">
                                <i className="ri-message-3-line text-teal-400 mt-0.5" />
                                <div>
                                    <p>SMS : AIDE au 5555</p>
                                    <p className="text-xs text-teal-400">Support rural disponible</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-2">
                                <i className="ri-mail-line text-teal-400 mt-0.5" />
                                <p>support@onapila.com</p>
                            </div>
                            <div className="flex items-start gap-2">
                                <i className="ri-map-pin-line text-teal-400 mt-0.5" />
                                <p>Conakry, Guinée</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom */}
                <div className="border-t border-teal-800 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-teal-400">
                    <p>© 2025 ONAPILA. Tous droits réservés.</p>
                    <div className="flex gap-6">
                        <a href="#" className="hover:text-orange-400 transition-colors">Confidentialité</a>
                        <a href="#" className="hover:text-orange-400 transition-colors">CGU</a>
                        <a href="#" className="hover:text-orange-400 transition-colors">Cookies</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default FooterSection;